import React from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

const ModalComponent = (props) => {
  const visionImpaired = useSelector((state) => state.layout.visionImpaired);
  const fontSize = useSelector((state) => state.layout.fontSize);

  return (
    <Modal
      {...props}
      animation={props.animation}
      show={props.show}
      onHide={props.onHide}
      size={props.size}
      centered
      style={{ zIndex: "999999" }}
      backdrop={props.backdrop}
      className={`${props.className} ${
        visionImpaired ? " visionImpaired" : ""
      }  font${fontSize}`}
    >
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{props.children}</Modal.Body>
    </Modal>
  );
};

export default ModalComponent;
